import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');

gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: 'SOME_TOKEN'
  }
}

export function* createCategoriaSaga( action ) {
  let ULRDestino = "api/admindata/categorias/";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action,
    method: metodo,
  });
  if(res.data.creado){
    yield put({ 
      type: actions.GET_CATEGORIAS
    });
  }
};

export function* deleteCategoriaSaga( action ) {
  let ULRDestino = "api/admindata/categorias/"+action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if(res.data.eliminado){
    yield put({ 
      type: actions.GET_CATEGORIAS
    });
  }
}

export function* getCategoriasSaga( action ) {
  const res = yield gaxios.request({
    url: 'api/admindata/categorias/',
  }); 
  yield put({ 
    type: actions.UPDATE_CATEGORIAS,
    categorias: res.data,
  });
}

export function* updateCategoriaSaga( action ) {
  let ULRDestino = "api/admindata/categorias/"+action.categoria.id;
  let metodo = "PUT";
  const data = action.categoria.icono
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: {icono: data},
  });
  if(res.data.actualizado){
    yield put({ 
      type: actions.GET_CATEGORIAS
    });
  }
}

export function* updateCodigosCartaSaga( action ) {
  let ULRDestino = `api/admindata/cartaMenu`;
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.data
  });
  if(res.data.success){
    notification('success', res.data.msg )
  }
};

/*CODIGOS */
export function* createCodigosSaga( action ) {
  let ULRDestino = `api/admindata/codigo/${action.number}`;
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.transaccion
  });
  if(res.data.success){
    notification('success', res.data.msg )
    yield put({ 
      type: actions.GET_CODIGOS
    });
  }
};

export function* deleteCodigosSaga( action ) {
  let ULRDestino = "api/admindata/codigo/"+action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if(res.data.success){
    notification('success', res.data.msg )
    yield put({ 
      type: actions.GET_CODIGOS
    });
  }
}

export function* getCodigosSaga( action ) {
  const res = yield gaxios.request({
    url: 'api/admindata/codigo/',
    headers: {
      Authorization:localStorage.getItem('access_token'),
      AuthId: localStorage.getItem('id_token')
    }
  }); 
  yield put({ 
    type: actions.UPDATE_CODIGOS,
    codigos: res.data.codes,
  });
}

export function* updateCodigosSaga( action ) {
  let ULRDestino = "api/admindata/codigo/"+action.categoria.id;
  let metodo = "PUT";
  const data = action.categoria.icono
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: {icono: data},
  });
  if(res.data.actualizado){
    yield put({ 
      type: actions.GET_CATEGORIAS
    });
  }
}

export function* enviarCodigoSaga( action ) {
  let ULRDestino = "api/admindata/codigo/send/";
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.data,
  });
  if(res.data.success){
    notification('success', res.data.msg );
    yield put({ 
      type: actions.GET_CODIGOS
    });
  }
}

export function* verificarCodigoSaga( action ) {
  let ULRDestino = "api/admindata/codigo/chk/"+action.codeChk+'/'+localStorage.getItem('id_token');
  const res = yield gaxios.request({
    url: ULRDestino,
  });
  let id;
  let verificado;
  if(res.data.success){
    id = res.data.code[0]._id
    verificado = true;
    notification('success', "Código verificado" );
  }else{
    id = null;
    verificado=false;
    notification('error', res.data.msg );
  }
  const codigoVerificado = {codigo:id,verificado};
  yield put({ 
    type: actions.CODIGO_VERIFICADO,
    codigoVerificado,
  });
}

/*INFO BASE */
export function* getInfoBase( action ){
  const res = yield gaxios.request({
    url: 'api/admindata/',
  }); 
  yield put({ 
    type: actions.UPDATE_INFO_BASE,
    categorias: res.data.categorias,
    totalEmpresas: res.data.totalEmpresas,
  });
}

/*USER INFO ESCRITORIO */
export function* infoUserEscritorio( action ){
  const res = yield gaxios.request({
    url: 'api/admindata/',
  }); 
  yield put({ 
    type: actions.UPDATE_INFO_BASE,
    categorias: res.data.categorias,
    totalEmpresas: res.data.totalEmpresas,
  });
}

export function* sendSMS( action ){
  const res = yield gaxios.request({
    url: 'api/send-sms/multiSMS',
    method: 'POST',
    data: action.data,
  });
  if (res.status === 200) {
    let msg = 'SMS enviado con éxito a: ';

    const tels = [...new Set( res.data.map(el => el.tel) )];
    tels.forEach((tel, i) => {
      if (i === tels.length -1 ) {
        msg += tel
      } else {
        msg += tel + ', '
      }
    });
    notification('success', msg);
  };
}

export function* sendEmail( action ){
  console.log(action);
  console.log(action.data);
  const res = yield gaxios.request({
    url: 'api/mensajes/multiEmails/',
    method: 'POST',
    data: action.data,
  });
  if (res.status === 201) {
    let msg = 'Email enviado con éxito a: ';

    const emails = [...new Set( res.data.map(el => el.email) )];
    emails.forEach((email, i) => {
      if (i === emails.length -1 ) {
        msg += email
      } else {
        msg += email + ', '
      }
    });
    notification('success', msg);
  };
}

export function* deleteBanner( action ){
  const res = yield gaxios.request({
    url: 'api/banners/'+action.id,
    method: 'DELETE',
  });
  if (res.status === 200) {
    notification('success', res.data.msg);
  };
}

export function* createBanner( action ){
  const res = yield gaxios.request({
    url: 'api/banners/',
    method: 'POST',
    data: action.banner,
  });
  if (res.status === 200) {
    notification('success', res.data.msg);
    console.log(res.data)
    yield put({ 
      type: actions.UPDATE_BANNERS,
      banners: res.data?.banners.filter(banner => banner.tipo === 'general'),
      bannerInicio: res.data?.banners.filter(banner => banner.tipo === 'inicio'),
    });
  };
}

export function* getBanner( action ){
  const res = yield gaxios.request({
    url: 'api/banners/',
  });
  yield put({ 
    type: actions.UPDATE_BANNERS,
    banners: res.data?.banners.filter(banner => banner.tipo === 'general'),
    bannerInicio: res.data?.banners.filter(banner => banner.tipo === 'inicio'),
  });
}


export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_INFO_BASE, getInfoBase),
    /*CATEGORIAS */
    yield takeEvery(actions.GET_CATEGORIAS, getCategoriasSaga),
    yield takeEvery(actions.CREATE_CATEGORIAS, createCategoriaSaga),
    yield takeEvery(actions.DELETE_CATEGORIAS, deleteCategoriaSaga),
    yield takeEvery(actions.UPDATE_CATEGORIA, updateCategoriaSaga),
    yield takeEvery(actions.ENVIAR_CODIGOS_CARTA, updateCodigosCartaSaga),

    /*CODIGOS */
    yield takeEvery(actions.GET_CODIGOS, getCodigosSaga),
    yield takeEvery(actions.CREATE_CODIGOS, createCodigosSaga),
    yield takeEvery(actions.DELETE_CODIGOS, deleteCodigosSaga),
    yield takeEvery(actions.UPDATE_CODIGO, updateCodigosSaga),
    yield takeEvery(actions.CHECK_CODIGO, verificarCodigoSaga),
    yield takeEvery(actions.ENVIAR_CODIGOS, enviarCodigoSaga),

    /*USER INFO */
    yield takeEvery(actions.GET_USER_INFO_DASHBOARD, infoUserEscritorio),
    
    /* SEND SMS */
    yield takeEvery(actions.SEND_SMS, sendSMS),
    yield takeEvery(actions.SEND_EMAIL, sendEmail),

     /* BANNERS */
     yield takeEvery(actions.DELETE_BANNER, deleteBanner),
     yield takeEvery(actions.CREATE_BANNER, createBanner),
     yield takeEvery(actions.GET_BANNERS, getBanner),

  ]);
}
